import React from 'react';

function AdminPlaceholderPage({ currentMenu }) {
    return (
        <div className="container-fluid" style={{ minHeight: '500px', backgroundColor: 'white', padding: '20px' }}>
            <div className="row-fluid">
                <div className="span12 text-center" style={{ marginTop: '50px' }}>
                    <i className="fa fa-wrench fa-5x" style={{ color: '#ccc', marginBottom: '20px' }} />
                    <h2>Chức năng {currentMenu} đang được phát triển</h2>
                    <p style={{ fontSize: '16px', color: '#666' }}>
                        Phần này hiện đang được nâng cấp hoặc trong quá trình chuyển đổi (migration) lên hệ thống mới.
                        Vui lòng quay lại sau!
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AdminPlaceholderPage;
